// extracted by mini-css-extract-plugin
export default {"card":"card__4CpVP","tools-container":"tools-container__xetod","certificate":"certificate__zKrmR"};